import { OxGristEditor } from './ox-grist-editor.js'
import { customElement } from 'lit/decorators.js'
import { html } from 'lit'
import moment from '@operato/moment-timezone-es'

function getSystemTimeZone(): string {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!timeZone) {
      throw new Error('Unable to resolve timeZone')
    }
    return timeZone
  } catch (e) {
    console.warn('Failed to get system timeZone, falling back to UTC.', e)
    return 'UTC'
  }
}

@customElement('ox-grist-editor-timezone')
export class OxGristEditorTimezone extends OxGristEditor {
  private static _timezoneOptions: string[] | null = null

  private static get TIMEZONE_OPTIONS() {
    if (!this._timezoneOptions) {
      const DEFAULT_TZ = getSystemTimeZone()
      this._timezoneOptions = ['', DEFAULT_TZ, ...moment.tz.names().filter((tz: string) => tz !== DEFAULT_TZ)]
    }
    return this._timezoneOptions
  }

  get editorTemplate() {
    return html`
      <select>
        ${OxGristEditorTimezone.TIMEZONE_OPTIONS.map(
          (tz: any) => html` <option ?selected=${tz == this.value} value=${tz}>${tz}</option> `
        )}
      </select>
    `
  }
}
